/*

	TABS:
	- Adds outline to focused element when user it navigating uses the TAB key.
	- Doesn't fire if the user is tabbing through a form.
	- Takes a css rule (string) to sytle the outline.

*/

const Tabs = function () {
	let outlinesEnabled = false;

	const _addEventListeners = outlineStyle => {
		window.addEventListener('keydown', e => {
			if (e.which === 9 && !document.activeElement.closest('form')) {
				outlinesEnabled = true;
			}
		});

		window.addEventListener('click', () => {
			outlinesEnabled = false;
		});

		window.addEventListener('focus', e => {
			if (!outlinesEnabled) return;
			if (typeof e.target === 'undefined' || typeof e.target.style === 'undefined') return;
			e.target.style.outline = outlineStyle;
			e.target.style.outlineOffset = '4px';
		}, true);

		window.addEventListener('blur', e => {
			if (!outlinesEnabled) return;
			if (typeof e.target === 'undefined' || typeof e.target.style === 'undefined') return;
			e.target.style.outline = 0;
		}, true);
	};

	return {
		init: string => {
			if (string != null && typeof string === 'string') {
				_addEventListeners(string);
			} else {
				throw new Error(`Tabs has been incorrectly initialized. Parameter must be an string, not a ${typeof obj}.`);
			}
		},

		addTabIndexToHeadings: () => {
			const headings = document.querySelectorAll('.js-article h1, .js-article h2, .js-article h3');
			for (let i = 0; i < headings.length; i++) {
				headings[i].setAttribute('tabindex', 0);
			}
		},
	};
}();

export { Tabs };



// WEBPACK FOOTER //
// ./assets/js/components/_accessibility.js